import ApiUrls from "../constants/ApiUrls";
import axios from "axios";
import { message } from "antd";
//import { history } from "..";
import { checkRedirect } from "../utils/error";

axios.interceptors.request.use(
  (config) => {
    config.params = { ...config.params };
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export function authConfigAxios(apiURL) {
  const requestBase = axios.create({
    baseURL: apiURL,
  });
  requestBase.interceptors.request.use(
    (config) => {
      config.params = { ...config.params };
      const token = localStorage.getItem("token");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
  );

  return requestBase;
}

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error?.response?.status === 401) {
      message.config({
        maxCount: 1,
      });
      if (
        !!error.response?.data?.message &&
        !error.response.hasBeenSentAlready
      ) {
        error.response.hasBeenSentAlready = true;
        if (error.response?.data?.message) {
          message.error(error.response.data.message);
        }
      }
      localStorage.removeItem("token");
      localStorage.removeItem("userOrgId");
      localStorage.removeItem("organizationId");
      localStorage.removeItem("userProfId");
      // history.push("/login");
      if (error.response?.data?.message) {
        message.destroy();
        message.error(error.response.data.message);
      }
    }
    checkRedirect(error);
    return Promise.reject(error);
  },
);

export function configAxios() {
  axios.defaults.baseURL = ApiUrls.webApiUrl;
}

export const authAPI = authConfigAxios(ApiUrls.authUrl);
export const webAPI = authConfigAxios(ApiUrls.webApiUrl);
